import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { DeleteDeviceSigningParams, OtpRequiredResponse } from '@repo/user-types'

const initialDeleteDeviceSigningState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: deleteDeviceSigningDataActions, reducer: deleteDeviceSigningDataReducer } =
  createOperationSlice<
    OtpRequiredResponse | null,
    SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
    DeleteDeviceSigningParams
  >({
    name: '@users/devices/delete-signing',
    initialState: initialDeleteDeviceSigningState,
    reducers: {},
  })
